var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./MainView.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-38d82418!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MainView.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/MainView.vue
// module id = 619
// module chunks = 0